/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: SubmitRequest = 1, DenyAppointment = 2
 */
export enum Routemize_Constants_TravelDistnaceExceedAction {
    SUBMIT_REQUEST = 'SubmitRequest',
    DENY_APPOINTMENT = 'DenyAppointment',
}
